import gql from "graphql-tag";

const gqlQuery = gql`
  query Source($sourceId: ID) {
    source(sourceId: $sourceId) {
      id
      use
      type
      brand
      privacyActivated
      disabled
      iaDisabled
      owner
      description
      deploymentNeeds
      firmwareUpdateAvailable
      currentFirmware
      serial
      model
      lastStatus
      lastThumbnail
      thumbnail
      dewarpDisabled
      scoreboardPerspective
      lastStatusOk
      usuallyDisconnected
      lastStatusKo
      lastChecked
      firstSeen
      publicInterface {
        adminUrl
        streamTcpUrl
        adminTcpPort
        adminSslPort
        adminTls
        ip
        videoStreamPort
        protocol
        secondCoachUrl
        ptzControllerPort
      }
      deploymentId
      deployment {
        id
        codename
      }
      firstActiveEventRelated {
        id
        title
      }
      users {
        admin {
          user
          pass
        }
        viewer {
          user
          pass
        }
      }
    }
  }
`;

export default sourceId => ({
  query: gqlQuery,
  variables: { sourceId },
});
